

function sortColorVariants() {
  document.querySelectorAll('.variant-picker__option-values[option-name="Color"]').forEach(function (container) {

    const highInventory = [];
    const lowInventory = [];

    const inputs = container.querySelectorAll('input[type="radio"]');

    inputs.forEach(function (input) {
      const label = container.querySelector(`label[for="${input.id}"]`);

      if (!label) return;

      const inventory = parseInt(input.dataset.variantInventory || 0, 10);

      if (inventory > 10) {
        highInventory.push([input, label]);
      } else {
        lowInventory.push([input, label]);
      }
    });

    // Remove existing Limited Edition heading
    const existingHeading = container.querySelector('.limited-edition-heading');
    if (existingHeading) {
      existingHeading.remove();
    }

    // Rebuild DOM
    container.innerHTML = '';

    // High inventory variants
    highInventory.forEach(function ([input, label]) {
      container.appendChild(input);
      container.appendChild(label);
    });

    // Limited Edition heading
    if (lowInventory.length) {
      const separator = document.createElement('div');
      separator.className = 'limited-edition-heading';
      separator.textContent = 'Limited Edition';
      container.appendChild(separator);
    }

    // Low inventory variants
    lowInventory.forEach(function ([input, label]) {
      container.appendChild(input);
      container.appendChild(label);
    });
  });
}

// Initial page load
document.addEventListener('DOMContentLoaded', function () {
  sortColorVariants();
});

// Re-run when variant changes
document.addEventListener('variant:change', function (event) {
  sortColorVariants();
});
document.addEventListener('variant:change', function () {
  setTimeout(function () {
    sortColorVariants();
  }, 100);
});